import React from "react";
import "./App.css";

export default function App() {
  return (
    <main>
      <h1>Pranav Sitaraman</h1>
      <nav>
        <a
          href="https://github.com/PranavSitaraman/"
          target="_blank"
          rel="noopener noreferrer"
        >
          GitHub
        </a>
        <a
          href="https://www.linkedin.com/in/pranavsitaraman/"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn
        </a>
        <a
          href="https://x.com/SitaramanPranav"
          target="_blank"
          rel="noopener noreferrer"
        >
          X
        </a>
        <a href="mailto:sitaraman.pranav@gmail.com">Email</a>
      </nav>
    </main>
  );
}
